
var collected = [];
const LOG_TYPES = ['log', 'info', 'warn', 'error'];

function log(...args) {
	const message = log.collect(...args);
	try {
		// console.log is not a normal function in IE9, so it doesn't have apply.
		Function.prototype.apply.call(console[message.type], console, message.log);
	} catch (e){}
}
LOG_TYPES.forEach(function(name) {
	log[name] = function(...args) {
		return log(name, ...args);
	};
});
log.getCollected = function() {
	return collected.slice(0);
};
log.collect = function(...args) {
	const message = {
		type: LOG_TYPES.includes(args[0]) ? args.splice(0, 1) : 'log',
		timestamp: new Date(),
		log: args,
	};
	collected.push(message);
	if (collected.length > 10) {
		collected.shift();
	}
	return message;
};

export default log;



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/rawr/utils/log.js
 **/